export function initTestimonials($) {
  $('.testimonials--slider').not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    speed: 500,
    infinite: true
  });
}
